import React, {useRef, useState, useEffect} from 'react'
import Divider from './Divider';
import VisDiv from './VisDiv';

const TextField = ({label, handwrittenLabel, description, textArea, isError, style={}, inputStyle={}, errorMessage, type="text", descriptionDivider=true, suffix, prefix, nChar, ...props}) => {
  const ref = useRef(null);
  const borderError = isError && "red"
  const [charCount, setCharCount] = useState(0);
  const handWrittenStyle = handwrittenLabel ? {fontFamily:"Caveat, cursive", fontSize:"20px"} : {}
  
  // Initialize character count based on initial value
  useEffect(() => {
    if (props.value && nChar && typeof nChar === 'number') {
      setCharCount(props.value.length);
    }
  }, [props.value, nChar]);
  
  const handleInput = (e) => {
    if (nChar && typeof nChar === 'number') {
      if (e.target.value.length > nChar) {
        e.target.value = e.target.value.slice(0, nChar);
      }
      setCharCount(e.target.value.length);
    }
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <div>
      <VisDiv style={{marginTop:"10px"}} rules={[label]}>
        <h4 style={handWrittenStyle}>{label}:</h4>
      </VisDiv>
    
      <div style={{...style, display:"flex", alignItems:"center", position: 'relative'}} className="text-input-container">
        <VisDiv rules={[prefix]} style={{marginRight: "10px"}}>
          {prefix}
        </VisDiv>
        <div style={{ position: 'relative', flex: 1 }}>
          <VisDiv rules={[!textArea]}>
            <input
              className='text-input'
              style={{
                borderColor: borderError,
                paddingBottom: nChar && typeof nChar === 'number' ? '35px' : undefined,
                width: '100%',
                ...inputStyle
              }}
              type={type}
              ref={ref}
              {...props}
              onChange={handleInput}
            />
          </VisDiv>
          <VisDiv rules={[textArea]}>
            <textarea
              className='text-input'
              style={{
                borderColor: borderError,
                paddingLeft: '10px',
                paddingRight: '10px',
                paddingTop: '10px',
                paddingBottom: nChar && typeof nChar === 'number' ? '35px' : undefined,
                width: '100%',
                ...inputStyle
              }}
              type={type}
              ref={ref}
              {...props}
              onChange={handleInput}
            />
          </VisDiv>

          {nChar && typeof nChar === 'number' && (
            <div style={{
              position: 'absolute',
              bottom: '12px',
              right: '10px',
              fontSize: '12px',
              color: charCount >= nChar ? '#ff4444' : '#666',
              padding: '2px 5px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '3px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              pointerEvents: 'none'
            }}>
              {charCount}/{nChar}
            </div>
          )}
        </div>
        <VisDiv rules={[suffix]} style={{marginLeft: "10px"}}>
          {suffix}
        </VisDiv>
      </div>

      {isError && <p style={{color:borderError, marginTop:"-20px"}}>{errorMessage}</p>}
      <p>{description}</p>
      <VisDiv rules={[description && descriptionDivider]}>
        <Divider/>
      </VisDiv>
    </div>
  )
}

export default TextField
